module.exports = __webpack_public_path__ + "img/5b14f93.jpg";